<template>
  <modal
    :show="show"
    @change="$emit('change', $event)"
    width="550"
    :headerClass="
      currentLocale === 'ru'
        ? 'bg-main-orange white--text helvetica-roman fs-18'
        : 'bg-main-orange white--text rubik-medium fs-18'
    "
  >
    <template v-slot:header>
      <span>{{ $t("modals.modalPayment.title") }}</span>
    </template>
    <template v-slot:main>
      <div v-if="paySuccess" class="modal-info text-center mx-7">
        <span class="d-block my-5">{{ $t("modals.modalPayment.sendNotification") }}</span>
        <v-form v-model="valid" ref="form">
          <div class="modalPayment__form-item">
            <div class="modalPayment__form-checkbox">
              <v-checkbox v-model="sendTo.email" class="pt-0 mt-0" color="orange" />
            </div>
            <div class="modalPayment__form-field">
              <v-text-field
                v-model="email"
                label="Email"
                outlined
                :rules="emailRules"
                :disabled="loading || !sendTo.email"
              ></v-text-field>
            </div>
          </div>

          <div class="modalPayment__form-item mt-1">
            <div class="modalPayment__form-checkbox">
              <v-checkbox v-model="sendTo.phone" class="pt-0 mt-0" color="orange" />
            </div>
            <div class="modalPayment__form-field">
              <v-text-field
                v-model="phone"
                label="Телефон"
                v-mask="'+7(###)###-##-##'"
                outlined
                :rules="phoneRules"
                :disabled="loading || !sendTo.phone"
              ></v-text-field>
            </div>
          </div>
          <v-btn
            @click="doPay()"
            class="orange-button mb-5"
            :class="{ 'button-font': currentLocale === 'tat' }"
            :disabled="!disabled"
            :loading="loading"
            >{{ $t("modals.modalPayment.toPay") }}
          </v-btn>
        </v-form>
      </div>
      <div v-if="!paySuccess" class="modal-info text-center mx-7 mt-10">
        <span class="d-block my-5">
          {{ $t("modals.modalPayment.serviceNotAvailable") }}
        </span>
        <v-btn @click="$emit('change', false)" class="orange-button mb-5 mt-5" :loading="loading"
          >{{ $t("buttons.close") }}
        </v-btn>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "../common/Modal";
import { mask } from "vue-the-mask";
import { mapGetters, mapState } from "vuex";
import { AxiosWrapper } from "@/assets/api/AxiosWrapper";

export default {
  name: "ModalPayment",
  directives: {
    mask
  },
  components: {
    Modal
  },
  model: {
    prop: "show",
    event: "change"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    toPay: {
      required: true,
      type: [Number, String],
      default: 0
    },
    details: {
      required: false,
      type: Array
    }
  },
  data: () => ({
    message: "",
    email: "",
    phone: "",
    sendTo: {
      email: false,
      phone: false
    },
    loading: false,
    paySuccess: true,
    valid: false
  }),
  computed: {
    ...mapState("account", ["selectedAccount"]),
    ...mapGetters("account", ["userSettings"]),
    ...mapGetters("locale", ["currentLocale"]),
    disabled() {
      if (this.sendTo.email) {
        return !!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/.test(this.email);
      } else if (this.sendTo.phone) {
        return !!/^\+7\(\d{3}\)\d{3}-\d{2}-\d{2}/.test(this.phone);
      } else {
        return false;
      }
    },
    phoneRules() {
      return [
        v => !!v || this.$t("modals.modalPayment.phoneNumber"),
        v => /^\+7\(\d{3}\)\d{3}-\d{2}-\d{2}/.test(v) || this.$t("rules.correctNumber")
      ];
    },
    emailRules() {
      return [
        v => !!v || this.$t("rules.inputEmail"),
        v => /^[^'"\|`~{}\[\]\/()\\=,<>\s\t]+$/.test(v) || this.$t("rules.badSymbols"),
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/.test(v) || this.$t("rules.inputCorrectEmail")
      ];
    }
  },
  methods: {
    doPay(testMode = false) {
      let postData = {
        appVersion: "LKFL",
        domHoz: this.selectedAccount.domHoz,
        userId: this.selectedAccount.isOwner ? this.userSettings.userGuid : this.selectedAccount.guid,
        amount: this.toPay
      };

      if (this.sendTo.phone && this.phone) {
        postData.phone = this.telEncode(this.phone);
      }

      if (this.sendTo.email && this.email) {
        postData.email = this.email;
      }

      if (this.details) {
        postData.details = this.details;
      }

      this.loading = true;

      if (testMode) {
        console.log("do pay test 1", this.selectedAccount);
        console.log("do pay test", postData);
        return;
      }

      AxiosWrapper.post("DoPay", postData)
        .then(response => {
          if (response.data.success) {
            // console.log(response.data)
            // return;
            window.open(response.data.url, "_top");
          } else {
            this.paySuccess = false;
            /*  this.$store.commit("common/" + "ADD_ALERT", {
              type: "error",
              text: response.data.message || "Произошла ошибка!",
            }); */
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    validate() {
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.validate();
        }
      });
    },
    telEncode(tel) {
      const encodedTel = "+" + tel.replace(/\D+/g, "");
      return encodedTel;
    }
  },
  created() {
    if (this.userSettings) {
      this.email = this.userSettings.email;
      this.phone = this.userSettings.phone;
      if (this.email.length > 0) this.sendTo.email = true;
      else if (this.phone.length > 0) this.sendTo.phone = true;
    }
    // this.loadData();
  },
  watch: {
    "sendTo.email": {
      immediate: true,
      handler(value) {
        if (value) {
          this.sendTo.phone = false;
        }
      }
    },
    "sendTo.phone": {
      immediate: true,
      handler(value) {
        if (value) {
          this.sendTo.email = false;
        }
      }
    }
  },
  mounted() {
    this.validate();
  }
};
</script>

<style lang="scss">
.modal-info {
  min-height: 200px;
  //display: flex;
  //flex-direction: column;

  &__message {
    margin: auto;
  }
}

.orange--checkbox {
  color: green !important;

  .accent--text {
    i {
      color: green !important;
    }
  }

  .v-application .accent--text {
    color: green !important;
  }
}

.modalPayment__form-item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  width: 100%;

  .modalPayment__form-checkbox {
    position: relative;
    height: max-content;
    padding: 5px 0 0 0;
  }

  .modalPayment__form-field {
    position: relative;
    width: calc(100% - 32px);
    height: max-content;
  }
}

.button-font {
  font-family: Rubik-Medium !important;
  white-space: normal;
}
</style>
